import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X } from "lucide-react";
import { api, toastErr } from "@/lib/api";
import { fanTitle, presenceText, isOnline } from "@/lib/presence";

// Header: name in large (internal site name if renamed), "@username · online / ultimo accesso…" below, pencil "Rinomina cliente" (site only, Telegram untouched).
export function ClientName({ conv, onRenamed }) {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/conversations/${conv.id}/rename`, { first_name: v.trim(), last_name: "" }); onRenamed(data); setEdit(false); toast.success("Cliente rinominato (solo nel sito)"); } catch (e) { toastErr(e); } finally { setBusy(false); }
  };
  const sub = [conv.fan_username && `@${conv.fan_username}`, presenceText(conv.tg_status)].filter(Boolean).join(" · ");
  if (edit) return (
    <div className="flex items-center gap-1" data-testid="rename-client-form">
      <input autoFocus value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && v.trim()) save(); if (e.key === "Escape") setEdit(false); }}
        className="h-7 w-56 rounded border border-[#232738] bg-[#12141D] px-2 text-sm outline-none focus:border-violet-500" data-testid="rename-client-input" />
      <button onClick={save} disabled={busy || !v.trim()} className="p-1 text-emerald-400 disabled:opacity-40" data-testid="rename-client-save"><Check className="h-4 w-4" /></button>
      <button onClick={() => setEdit(false)} className="p-1 text-slate-400" data-testid="rename-client-cancel"><X className="h-4 w-4" /></button>
    </div>
  );
  return (
    <>
      <div className="flex items-center gap-1.5 min-w-0">
        <span className="text-base font-bold truncate" data-testid="chat-fan-name">{fanTitle(conv)}</span>
        <button onClick={() => { setV(fanTitle(conv).replace(/^@/, "")); setEdit(true); }} title="Rinomina cliente" className="p-0.5 text-slate-500 hover:text-white shrink-0" data-testid="rename-client-btn"><Pencil className="h-3.5 w-3.5" /></button>
      </div>
      <div className={`text-[11px] truncate ${isOnline(conv.tg_status) ? "text-emerald-400" : "text-slate-500"}`} data-testid="chat-fan-status">{sub}</div>
    </>
  );
}
